'use strict';

import Chartist from 'chartist';

class Donut {
  constructor (config) {
    const self = this;
    self.el = config.el;
    self.series = JSON.parse(self.el.getAttribute('data-series'));
    self.initializeChart();
  }

  initializeChart () {
    const self = this;
    new Chartist.Pie(self.el, {
      series: self.series
    }, {
      donut: true,
      donutWidth: 28,
      startAngle: 0,
      total: 100,
      showLabel: false
    });
  }
}

const donuts = document.querySelectorAll('.DonutChart');
[].forEach.call(donuts, donut => {
  new Donut({el: donut});
});



// WEBPACK FOOTER //
// ./app/javascript/modules/donut.js